import { clearInitialSiteLoadQuery, getInitialSiteLoadQuery } from "@iewccouk/Utilities/initialSiteLoadQuery";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { request } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/contactusform/sendmail";

type SubmitRequestQuoteFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitRequestQuoteFormParameter, FormData>;

export const PopulateApiParameter: HandlerType = async (props: any) => {
    const state = (props.getState() as any).customRequestQuoteForm;
    props.apiParameter = {} as any;
    props.apiParameter.Company = state.fieldValues["company"];
    props.apiParameter.FirstName = state.fieldValues["firstName"];
    props.apiParameter.LastName = state.fieldValues["lastName"];
    props.apiParameter.PostalCode = state.fieldValues["zipCode"];
    props.apiParameter.Country = state.fieldValues["country"];
    props.apiParameter.State = state.fieldValues["state"];
    props.apiParameter.Comments = state.fieldValues["comments"];
    props.apiParameter.TypeOfRequest = state.fieldValues["typeOfRequest"];
    props.apiParameter.TypeOfRequestHidden = state.fieldValues["typeOfRequest"];
    props.apiParameter.EmailAddress = state.fieldValues["email"];
    props.apiParameter.RegularUpdates = state.fieldValues["regularUpdates"];

    const initialSiteLoad = getInitialSiteLoadQuery();
    if (initialSiteLoad?.queryParams) {
        for (const [key, raw] of Object.entries(initialSiteLoad.queryParams)) {
            if (raw === "" || (Array.isArray(raw) && raw.length === 0)) {
                continue;
            }
            props.apiParameter[key] = Array.isArray(raw) ? raw.join(",") : raw;
        }
    }

    const files = await Promise.all(
        [state.fieldValues.fileOne, state.fieldValues.fileTwo].filter(Boolean).map(
            (file: any) =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                }),
        ),
    );

    files.forEach((file, index) => {
        props.apiParameter[`FileUpload${index + 1}`] = file;
    });

    if (state.fieldValues.fileOne) {
        props.apiParameter.FileUploadName1 = state.fieldValues.fileOne.name;
    }

    if (state.fieldValues.fileTwo) {
        props.apiParameter.FileUploadName2 = state.fieldValues.fileTwo.name;
    }

    props.apiParameter.EmailTo = props.parameter.emailRecipients;

    clearInitialSiteLoadQuery();
};

export function multipart<Parameter, Result = Parameter>(endpoint: string, formData?: any) {
    const emailTo = formData.EmailTo;
    delete formData.EmailTo;
    return request<Result>(
        `${endpoint}?EmailTo=${emailTo}`,
        "POST",
        { Accept: "application/json", "Content-Type": "application/json" },
        JSON.stringify(formData),
    );
}

export function submitRequestQuoteFormApi(parameter: any) {
    return multipart<any, void>(`${emailsUrl}`, parameter);
}

export const SendDataToApi: HandlerType = async props => {
    await submitRequestQuoteFormApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitRequestQuoteForm = createHandlerChainRunner(chain, "SubmitContactForm");
export default submitRequestQuoteForm;
